<template>
  <svg
    class="weui-icon-svg"
    width="22px"
    height="23px"
    :style="{'font-size':pxToRem(size) }"
    viewBox="0 0 22 23"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
    <g id="香港CDD" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g
        id="香港-CDD-3备份"
        transform="translate(-303.000000, -820.000000)"
        :fill="fill"
        fill-rule="nonzero"
      >
        <g id="编组" transform="translate(303.000000, 811.000000)">
          <g id="refresh" transform="translate(0.000000, 9.000000)">
            <path
              d="M20,12 C20,16.963 15.963,21 11,21 C6.037,21 2,16.963 2,12 C2,7.037 6.037,3 11,3 C12.989,3 14.873,3.65 16.43,4.833 L12.826,8.226 L21.993,9.209 L21.562,0 L17.907,3.442 C15.957,1.862 13.545,1 11,1 C4.935,1 0,5.935 0,12 C0,18.065 4.935,23 11,23 C17.065,23 22,18.065 22,12 L20,12 Z"
              id="路径"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator';
import mixins from '../mixins';
@Component
export default class FitCheckbox extends Mixins(mixins) {
  @Prop({ default: '#576B95' }) fill;
  @Prop({ default: 26 }) size;
}
</script>
